import { createRoot } from "react-dom/client";
import "@fontsource/inter/400.css";
import "@fontsource/inter/700.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/700.css";
import "@fontsource/open-sans/400.css";
import "@fontsource/open-sans/700.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/700.css";
import "./index.css";
import App from "./App.tsx";
import { Provider } from "react-redux";
import { store } from "@/shared/store/index.ts";
import { configureAxiosInterceptor } from "@retro-ia/shared/axios";
import { logout } from "@retro-ia/shared/auth";

configureAxiosInterceptor(() => store, logout);

createRoot(document.getElementById("root")!).render(
  <Provider store={store}>
    <App /> 
  </Provider>
);
